<div class="invoice-counter-dialog">
  <div class="invoice-counter-dialog-header flex-between-center">
    <div class="m-0 font-bold flex-start-center">
      <i class="far fa-ballot-check font-gray-45 pr-2"></i>
      <p class="m-0 font-gray-45">Invoice counter</p>
    </div>

    <span class="close-modal">
      <i class="fal fa-times" (click)="handleClose()"></i>
    </span>
  </div>

  <div class="invoice-counter-dialog-body flex-column flex-start-start">
    <p class="m-0 font-bold font-gray-45">
      Future Invoices will start counting up from the below counter
    </p>

    <div class="ui-g p-0 width-100p mt-5">
      <div class="ui-g-12 p-0">
        <div class="ui-g-6 p-0 flex-start-center">
          <i class="far fa-stopwatch font-gray-45 pr-2"></i>
          <app-input class="width-100p" placeholder="Current Invoice counter" [floatingLabel]="true"
            [value]="currentInvoiceCounter" [disabled]="true"></app-input>
        </div>

        <div class="ui-g-6 p-0 flex-start-center">
          <i class="far fa-cabinet-filing font-gray-45 pr-2"></i>

          <app-input class="width-100p" placeholder="New Invoice counter" mask="00000000" [floatingLabel]="true"
            [isInvalid]="error" [errorMessage]="error" [value]="newInvoiceCounter" (appChange)="handleChange($event)"
            (appFocus)="error = ''" (appBlur)="handleBlur()"></app-input>
        </div>
      </div>
    </div>

  </div>

  <div class="invoice-counter-dialog-footer flex-end-center">
    <button class="btn btn-border pointer btn-submit mr-1" (click)="handleClose()">Cancel</button>
    <button class="btn btn-primary btn-submit" [disabled]="isProcessing || isSaveDisabled()" (click)="handleSubmit()">
      Save
      <i class="fal fa-spinner rotate" *ngIf="isProcessing"></i>
    </button>
  </div>
</div>
